import React from 'react';
// import { Navigate } from 'react-router-dom';
// import { CiatAppContext } from '../../providers';
import LogoutContent from './authentication/LogoutContent';
import AuthCardLayout from './authentication/AuthCardLayout';

function Logout() {
  // const { logoutHandler } = useContext(CiatAppContext);
  // logoutHandler();
  return (
  // <Navigate to="/" replace />
    <AuthCardLayout>
      <div className="text-center">
        <LogoutContent layout="card" titleTag="h3" />
      </div>
    </AuthCardLayout>
  );
}

export default Logout;
